module.exports = __webpack_public_path__ + "static/img/photo-8.4ed36117.jpg";